import { useContext } from "react";
import LanguageConfigsContext from "../context/LanguageConfigContext";

export default function useLanguageConfigs() {
  return useContext(LanguageConfigsContext);
}
